var moduleMap = {
	"./Attendance": function() {
		return Promise.all([__webpack_require__.e(8243), __webpack_require__.e(9173), __webpack_require__.e(4797), __webpack_require__.e(6802), __webpack_require__.e(930), __webpack_require__.e(2796), __webpack_require__.e(8416), __webpack_require__.e(8327), __webpack_require__.e(2021), __webpack_require__.e(1954), __webpack_require__.e(7591), __webpack_require__.e(334), __webpack_require__.e(2081), __webpack_require__.e(1745), __webpack_require__.e(6128), __webpack_require__.e(5020), __webpack_require__.e(37)]).then(function() { return function() { return (__webpack_require__(75020)); }; });
	},
	"./TakeAttendance": function() {
		return Promise.all([__webpack_require__.e(8243), __webpack_require__.e(9173), __webpack_require__.e(4797), __webpack_require__.e(2796), __webpack_require__.e(8416), __webpack_require__.e(8327), __webpack_require__.e(2021), __webpack_require__.e(1954), __webpack_require__.e(7591), __webpack_require__.e(334), __webpack_require__.e(1745), __webpack_require__.e(9701)]).then(function() { return function() { return (__webpack_require__(81954)); }; });
	},
	"./AttendanceInsights": function() {
		return Promise.all([__webpack_require__.e(8243), __webpack_require__.e(9173), __webpack_require__.e(4797), __webpack_require__.e(6802), __webpack_require__.e(1024), __webpack_require__.e(2796), __webpack_require__.e(8416), __webpack_require__.e(8327), __webpack_require__.e(2021), __webpack_require__.e(7591), __webpack_require__.e(2081), __webpack_require__.e(1745), __webpack_require__.e(6128), __webpack_require__.e(4602), __webpack_require__.e(780)]).then(function() { return function() { return (__webpack_require__(14602)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});